import { useState } from 'react'
import { Button, Message } from '@arco-design/web-react'
import { testMonitorAlertApi } from '@/api/monitor'
import type { OptionsAPI } from '../useOptions'

interface Props {
  options: OptionsAPI
  disabled?: boolean
}

export default function DingTalkWebhookTestButton({ options, disabled }: Props) {
  const { get, values } = options
  const [loading, setLoading] = useState(false)

  const handleTest = async () => {
    setLoading(true)
    try {
      const webhook = values['alert_setting.dingtalk_webhook_url'] ?? get('alert_setting.dingtalk_webhook_url')
      const secret = values['alert_setting.dingtalk_secret'] ?? get('alert_setting.dingtalk_secret')
      const mention = values['alert_setting.mention_mobiles'] ?? get('alert_setting.mention_mobiles')
      const res = await testMonitorAlertApi({
        webhook_url: webhook || undefined,
        secret: secret || undefined,
        mention_mobiles: mention || undefined,
      })
      Message.success(res.message ?? '测试消息已发送')
    } catch (e) {
      Message.error(e instanceof Error ? e.message : '发送失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button type="outline" loading={loading} disabled={disabled} onClick={handleTest}>
      发送钉钉测试消息
    </Button>
  )
}
